<template>
<div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
            <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar" style="cursor:pointer">view_headline</i>
            <app-navbar></app-navbar>
        

            <template>
                <div class="container-fluid">
                    <div class="row mt-5">
                        <div class="col-md-12 mt-2 mb-2">
                            <h2 style="color: #00a4ea">Manage Social Media</h2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">

                            <b-card class=" shadow-sm rounded" title="Select Event">
                                <b-form-group>
                                    <multiselect
                                       v-model="selectedTraining"
                                       :options="trainingArr"
                                       :custom-label="option => option.title"
                                       track-by="id"
                                       placeholder="Search or Select Event"
                                       :multiple="false"
                                     >
                                       <!-- Custom option slot -->
                                       <template #option="props">
                                         <div class="option-custom">
                                           <strong>{{ props.option.title }}</strong><br />
                                           <small>{{ formatDate3(props.option.startdate) }} to {{ formatDate3(props.option.enddate) }}</small><br />
                                           <small>{{ props.option.venue }}</small>
                                         </div>
                                       </template>
                                     
                                       <!-- Custom selected value slot -->
                                       <template #singleLabel="props">
                                         <div class="option-custom">
                                           <strong>{{ props.option.title }}</strong><br />
                                          
                                         </div>
                                       </template>
                                     </multiselect>


                                    <!-- <multiselect v-model="selectedTraining" :options="trainingArr" label="title" placeholder="Search or Select Event" :multiple="false" track-by="id"></multiselect> -->
                                </b-form-group>
                            </b-card>

                        </div>
                    </div>

                    <div class="row" v-if="selectedTraining">
                        <div class="col-md-12">
                            <template>
                                <div class="row mt-4">
                                    <div class="col-md-4">
                                        <div class="card mb-3 shadow card-hover">
                                            <div class="card-body2 d-flex align-items-start">
                                                <div class="pt-1">
                                                    <i class="fas fa-calendar-alt fa-2x text-primary"></i>
                                                </div>
                                                <div class="ml-3">
                                                    <h5 class="card-title text-muted">Event Name</h5>
                                                    <p class="card-text mb-0 font-weight-bold">{{ eventName }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="card mb-3 shadow card-hover">
                                            <div class="card-body2 d-flex align-items-start">
                                                <div class="pt-1">
                                                    <i class="fas fa-building fa-2x text-primary"></i>
                                                </div>
                                                <div class="ml-3">
                                                    <h5 class="card-title text-muted">Department</h5>
                                                    <p class="card-text mb-0 font-weight-bold">{{ getDepartmentName(eventDetails?.department_id) }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="card mb-3 shadow card-hover">
                                            <div class="card-body2 d-flex align-items-start">
                                                <div class="pt-1">
                                                    <i class="fas fa-user-tie fa-2x text-primary"></i>
                                                </div>
                                                <div class="ml-3">
                                                    <h5 class="card-title text-muted">Program Officer</h5>
                                                    <p class="card-text mb-0 font-weight-bold">{{ getProgramOfficerName(eventDetails?.programofficer_id) }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="card mb-3 shadow card-hover">
                                            <div class="card-body2 d-flex align-items-start">
                                                <div class="pt-1">
                                                    <i class="fas fa-hand-holding-usd fa-2x text-primary"></i>
                                                </div>
                                                <div class="ml-3">
                                                    <h5 class="card-title text-muted">Donor</h5>
                                                    <p class="card-text mb-0 font-weight-bold">{{ getDonerName(eventDetails?.doner_id) }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="card mb-3 shadow card-hover">
                                            <div class="card-body2 d-flex align-items-start">
                                                <div class="pt-1">
                                                    <i class="fas fa-calendar-day fa-2x text-primary"></i>
                                                </div>
                                                <div class="ml-3">
                                                    <h5 class="card-title text-muted">Dates</h5>
                                                    <p class="card-text mb-0 font-weight-bold">{{ formatDate(eventDetails?.startdate) }} - {{ formatDate(eventDetails?.enddate) }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="card mb-3 shadow card-hover cursor-pointer">
                                            <div class="card-body2 d-flex align-items-start">
                                                <div class="pt-1">
                                                    <i class="fas fa-clock fa-2x text-primary"></i>
                                                </div>
                                                <div class="ml-3">
                                                    <h5 class="card-title text-muted">Number of Days</h5>
                                                    <p class="card-text mb-0 font-weight-bold">{{ eventDetails?.noofdays }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="card mb-3 shadow card-hover cursor-pointer">
                                            <div class="card-body2 d-flex align-items-start">
                                                <div class="pt-1">
                                                    <i class="fas fa-map-marker-alt fa-2x text-primary"></i>
                                                </div>
                                                <div class="ml-3">
                                                    <h5 class="card-title text-muted">Location</h5>
                                                    <p class="card-text mb-0 font-weight-bold">{{ getLocationName(eventDetails?.district_id) }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="card mb-3 shadow card-hover cursor-pointer">
                                            <div class="card-body2 d-flex align-items-start">
                                                <div class="pt-1">
                                                    <i class="fas fa-map-marker-alt fa-2x text-primary"></i>
                                                </div>
                                                <div class="ml-3">
                                                    <h5 class="card-title text-muted">Venue</h5>
                                                    <p class="card-text mb-0 font-weight-bold">{{ eventDetails?.venue }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>

                    </div>
                    <div class="row" v-if="selectedTraining">
                        <div class="col-md-7">
                            <div class="row justify-content-center">
                                <div class="col-md-11">
                                    <b-card class="p-4 shadow-sm rounded">

                                        <div>
                                            <div v-for="(field, index) in socialFields" :key="index" class="mb-3 input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">
                                                        <i :class="field.icon"></i>
                                                    </span>
                                                </div>
                                                <b-form-input v-model="field.value" :placeholder="`Enter ${field.label} link`" class="form-control" :class="{ 'is-invalid': field.value && !validateUrl(field.value) }" @blur="handleBlur(field)"></b-form-input>
                                                <div class="invalid-feedback" v-if="field.value && !validateUrl(field.value)">
                                                    URL must start with https://
                                                </div>
                                            </div>

                                            <!-- <b-button variant="primary" @click="save" block>Save</b-button> -->
                                        </div>
                                    </b-card>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-5">

                            <template v-if="selectedTraining">
                                <div style="max-width: 420px; margin: 6px auto; box-shadow: 0 4px 12px rgba(0,0,0,0.2); border-radius: 10px; overflow: hidden; position: relative;">
                                    <!-- Header -->
                                    <div style="background-color: #06a6e0; color: white; padding: 16px 20px; font-size: 1.2em; font-weight: bold; position: relative;">
                                        <div style="width: 90%;">{{ eventName }}</div>
                                        <button @click="copyAllLinks" title="Copy All" style="position: absolute; right: 20px; top: 12px; background: transparent; border: none; cursor: pointer; font-size: 1.2em; color: white;">
                                            🗐
                                        </button>

                                    </div>

                                    <!-- Links -->
                                    <div style="padding: 16px 20px; background: #fff; display: flex; flex-direction: column; gap: 12px;">
                                        <div v-for="link in socialFields" :key="link.label" style="background: #f2f2f2; padding: 12px; border-radius: 8px; overflow: auto;">
                                            <div style="font-weight: bold;">
                                                {{ link.icon2 }} {{ link.label }}:
                                                <button @click="copySingle(link)" style="float: right; background: transparent; border: none; cursor: pointer; font-size: 1.1em; color: #555;">
                                                    🗐
                                                </button>
                                            </div>
                                            <div style="padding-left: 26px;">{{ link.value }}</div>
                                        </div>
                                    </div>

                                </div>

                            </template>
                        </div>
                    </div>
                    <div>

                        <div class="row mt-2" v-if="selectedTraining">
                            <h5 class="image-heading">Group Photo</h5>
                            <div class="col-md-12">

                                <div class="card shadow  p-4">
                                    <div class="row justify-content-center">
                                        <div class="col-md-8">

                                            <!-- Image preview OR placeholder -->
                                            <div class="text-center mb-4">
                                                <div v-if="imageUrl">
                                                    <img :src="imageUrl" alt="Preview" class="img-fluid rounded shadow border" />
                                                </div>
                                                <div v-else class="text-muted">
                                                    <img src="../../../assets/group-photo-icon.png" class="img-fluid mobile-logo-img mt-2" /> <!-- Group photo icon -->
                                                    <div>Upload Group Photo</div>
                                                </div>
                                            </div>

                                            <!-- File input + Upload button -->
                                            <div class="row justify-content-center align-items-center">
                                                <div class="col-md-6 text-center mt-2">
                                                    <input type="file" id="customFileUpload" accept="image/*" class="d-none" @change="handleFileChange" />
                                                    <label for="customFileUpload" class="btn btn-outline-primary w-100">
                                                        <i class="fa fa-image me-2"></i> Choose Group Photo
                                                    </label>
                                                </div>

                                            </div>

                                            <!-- Help Text -->
                                            <div class="text-center mt-3 text-muted">
                                                <small>Maximum file size: 3MB. Allowed formats: JPG, PNG</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 mb-4 mt-1">

                                <button class="btn btn-success w-100 mb-4" @click="uploadImage" >
                                    <i class="fa fa-upload me-2"></i> Upload & Save
                                </button>

                            </div>
                        </div>

                    </div>
                </div>
            </template>


        </div>
    </div>
</div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { formatDate ,formatDate3 } from "@/utils/DateFormate";


export default {
    data: () => ({
        isSidebar: false,
        trainingArr: [],
        selectedTraining: null,
        socialFields: [{
                label: 'X (Twitter)',
                icon: 'fa-brands fa-x-twitter',
                value: '',
                icon2: "🐤"
            },
            {
                label: 'Facebook',
                icon: 'fa-brands fa-facebook-f',
                value: '',
                icon2: "🟦"
            },
            {
                label: 'LinkedIn',
                icon: 'fa-brands fa-linkedin-in',
                value: '',
                icon2: "💼"
            },
            {
                label: 'Instagram',
                icon: 'fa-brands fa-instagram',
                value: '',
                icon2: "📷"
            },

            {
                label: 'Web Story',
                icon: 'fa-solid fa-globe',
                value: '',
                icon2: "🌐"
            }
        ],
        eventName: "",
        trainingArr: [],
        trainingId: null,
        selectedTraining: null,

        eventDetails: {},
        file: null,
        imageUrl: null,
        districtArr: [],
        departmentArr: [],
        programOfficerArr: [],
        donernameArr: [],
    }),

    components: {
        "app-navbar": Navbar,
        "app-sidebar": Sidebar,
        Multiselect,
    },
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.allTrainings();
        this.openLoading();
        Promise.all([
            axios.get(process.env.VUE_APP_BASE_PATH + "/districts/get"),
            axios.get(process.env.VUE_APP_BASE_PATH + "/departments/get"),
            axios.get(process.env.VUE_APP_BASE_PATH + "/programofficer/get"),
            axios.get(process.env.VUE_APP_BASE_PATH + "/donernames/get")
        ]).then(([districts, departments, programOfficers, doners]) => {
            this.districtArr = districts.data;
            this.departmentArr = departments.data;
            this.programOfficerArr = programOfficers.data;
            this.donernameArr = doners.data;
            this.closeLoading();
        }).catch(error => {
            this.closeLoading();
            this.handleApiError(error);
        });
    },
    methods: {
        formatDate,
        formatDate3,

        allTrainings() {
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/get/all/training/reports/admin/" +
                    JSON.parse(localStorage.getItem("currentUser")).id

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.trainingArr = response.data;

                });
        },
        handleTrainingChange() {
            // Clear previous inputs if needed
            this.socialFields.forEach(field => (field.value = ''));
        },
        save() {
            if (!this.validateAllUrls()) {
                this.showUrlError();
                return;
            }

            this.openLoading();

            let payload = {
                twitter_link: this.socialFields[0].value,
                facebook_link: this.socialFields[1].value,
                linkedin_link: this.socialFields[2].value,
                insta_link: this.socialFields[3].value,
                web_link: this.socialFields[4].value
            };

            if (process.env.VUE_APP_BASE_PATH == "https://dev.tmisodc.org/dapi") {
                payload.isDev = true;
            }

            axios.put(
                    process.env.VUE_APP_BASE_PATH + `/training/update-links/${this.selectedTraining.id}`,
                    payload
                )
                .then(response => {
                    this.closeLoading();
                    if (response.data) {
                        this.toastSuccess('Links updated successfully');
                    } else {
                        this.toastError(response.data.message || 'Failed to update status');
                    }
                })
                .catch(error => {
                    this.closeLoading();
                    this.toastError('Error updating status');
                });
        },

        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true
            });
        },
        fetchSocialLinks(trainingId) {
            this.openLoading();
            axios
                .get(`${process.env.VUE_APP_BASE_PATH}/training/media/${trainingId}`)
                .then(response => {
                    this.closeLoading();
                    const data = response.data.media;
                    this.socialFields[0].value = data.twitter_link || '';
                    this.socialFields[1].value = data.facebook_link || '';
                    this.socialFields[2].value = data.linkedin_link || '';
                    this.socialFields[3].value = data.insta_link || ''; // Added Instagram
                    this.socialFields[4].value = data.web_link || ''; // Updated index for web link
                })
                .catch(error => {
                    this.closeLoading();
                    this.toastError('Failed to fetch social links');
                    console.error(error);
                });
        },
        copySingle(link) {
            const formattedText = `*Event: ${this.eventName}*\n${link.icon2} *${link.label}:*\n${link.value}`;
            navigator.clipboard.writeText(formattedText).then(() => {
                this.toastSuccess(`${link.label} link copied!`);
            });
        },
        copyAllLinks() {
            const filledLinks = this.socialFields.filter(link => (link.value || '').trim());
            let formattedText = `*Event: ${this.eventName}*`;
            if (filledLinks.length) {
                formattedText += '\n\n' + filledLinks.map(link =>
                    `${link.icon2} *${link.label}:*\n${link.value}`
                ).join('\n\n');
            }

            navigator.clipboard.writeText(formattedText).then(() => {
                this.toastSuccess('All links copied!');
            });
        },
        getDepartmentName(id) {
            if (!id) return 'N/A';

            // If multiple IDs are given as a comma-separated string
            const ids = typeof id === 'string' ? id.split(',') : Array.isArray(id) ? id : [id];

            const names = ids
                .map(i => {
                    const deptId = String(i).trim();
                    const dept = this.departmentArr.find(d => String(d.id) == deptId);
                    return dept ? dept.title : null;
                })
                .filter(Boolean); // Remove any null values

            return names.length ? names.join(', ') : 'N/A';
        },

        getProgramOfficerName(id) {
            if (!id) return 'N/A';
            const officer = this.programOfficerArr.find(p => p.id == id);
            return officer ? officer.name : 'N/A';
        },

        getDonerName(id) {
            if (!id) return 'N/A';

            let ids = [];

            if (typeof id === 'string') {
                ids = id.split(',');
            } else if (Array.isArray(id)) {
                ids = id;
            } else {
                ids = [id];
            }

            const names = ids
                .map(i => {
                    const donerId = String(i).trim();
                    const doner = this.donernameArr.find(d => String(d.id) === donerId);
                    return doner ? doner.title : null;
                })
                .filter(Boolean); // Remove any nulls

            return names.length ? names.join(', ') : 'N/A';
        },
        getLocationName(id) {
            if (!id) return 'N/A';
            const location = this.districtArr.find(d => d.id == id);
            return location ? location.title + ', ' + location.province.title + ', ' + location.province.country.title : 'N/A';
        },

        handleFileChange(event) {
            const selectedFile = event.target.files[0];
            const maxSizeMB = 3;
            const allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];

            if (!selectedFile) {
                this.toastError("No file selected.");
                this.file = null;
                this.imageUrl = null;
                return;
            }

            if (selectedFile.size / (1024 * 1024) > maxSizeMB) {
                this.toastError("Image must be less than 3MB.");
                return;
            }

            if (!allowedTypes.includes(selectedFile.type)) {
                this.toastError("Only JPG, PNG images are allowed.");
                return;
            }

            this.file = selectedFile;

            // Show preview
            const reader = new FileReader();
            reader.onload = e => {
                this.imageUrl = e.target.result;
            };
            reader.readAsDataURL(selectedFile);
        },

        uploadImage() {
            if (!this.validateAllUrls()) {
                this.showUrlError();
                return;
            }
            this.openLoading();
            this.save(); // This will save the URLs first

            if (this.file != null) {
                const formData = new FormData();
            formData.append("training_image", this.file);

            axios.put(
                    `${process.env.VUE_APP_BASE_PATH}/training/update-image/${this.trainingId}`,
                    formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            Authorization: localStorage.getItem("token"),
                        },
                    }
                )
                .then((response) => {
                    this.closeLoading();
                    if (response.data) {
                        this.toastSuccess("Image uploaded successfully!");
                        this.imageUrl = process.env.VUE_APP_BASE_PATH + "/" + response.data.training_image;
                        this.file = null;
                    } else {
                        this.toastError("Upload failed. Please try again.");
                    }
                })
                .catch((error) => {
                    this.closeLoading();
                    this.toastError("Error during upload: " + (error.response?.data?.message || error.message));
                });
            }

            

           
        },

        handleUnauthorized() {
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
        },
        handleTokenExpired(message) {
            this.$toasted.global.errorMsg(message);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
        },

        handleApiError(error) {
            if (error.response?.data?.unAuth) {
                this.handleUnauthorized();
            } else if (error.response?.data?.tokenExpired) {
                this.handleTokenExpired(error.response.data.tokenExpired);
            } else {
                this.toastError("An error occurred. Please try again.");
                console.error(error);
            }
        },
        validateUrl(url) {
            return url === '' || url.startsWith('https://') || url.startsWith('http://');
        },

        validateAllUrls() {
            return this.socialFields.every(field => this.validateUrl(field.value));
        },

        showUrlError() {
            this.$toasted.global.errorMsg('Please enter valid URL in Social Media Fields (must start with https://)');
        },
        handleBlur(field) {
            if (field.value && !this.validateUrl(field.value)) {
                this.showUrlError();
            }
        },
    },
    watch: {
        selectedTraining(newVal) {
            if (newVal && newVal.id) {
                this.fetchSocialLinks(newVal.id);
                this.eventName = newVal.title;
                this.eventDetails = newVal;
                this.trainingId = newVal.id;
                this.imageUrl = newVal.training_image ?
                    process.env.VUE_APP_BASE_PATH + "/" + newVal.training_image :
                    null;
                this.file = null;
            }
        }
    },

};
</script>

<style scoped>
.myNavbar {
    color: rgb(255, 255, 255);
}

@media (max-width: 768px) {}

.input-group-text {
    width: 45px;
    justify-content: center;
    background-color: #f1f1f1;
}

.input-group-text {
    width: 45px;
    justify-content: center;
    background-color: #f1f1f1;
}

.image-heading {
    font-size: 30px;
    font-weight: 600;
    font-family: 'Poppins', sans-serif;
    margin-left: 20px;
    background-color: #06a6e0;
    color: white;
    padding: 5px 12px;
    border-radius: 5px;
    margin-top: 8px;

}

.card-hover:hover {
    transform: translateY(-2px);
    transition: transform 0.2s ease;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
}

.card-body2 {
    padding: 1.25rem;
}

.text-muted {
    color: #6c757d !important;
}

.font-weight-bold {
    font-weight: 600 !important;
}

.text-primary {
    color: #00a4ea !important;
}
.option-custom {
  line-height: 1.4;
  padding: 5px 0;
}

</style>
